import './scripts/common';
import onInitModulesInScope from "./scripts/onInitModulesInScope";

if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

let app = window['app'] || {
    debug: false,
};

window.app = app || {};
window.app.modules =  app.modules || {};

import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('./scripts/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as affix from '@elements/affix';
onInitModulesInScope(affix.createInitInScope({
    mediaQuery: '(min-width: 768px)'
}));
onInitModulesInScope(affix.createInitInScope({
        breakpoints: {
            768: {
                offset: 60
            },
        }
    },
    {
        base: '.js-affix-detail-bar',
        placeholder: '.js-affix-detail-bar__placeholder',
        container: '.js-affix-detail-bar__container'
    }));

import * as productSlider from './scripts/product-slider';
onInitModulesInScope(productSlider.initInScope);

import * as changeModal from './scripts/change-modal';
onInitModulesInScope(changeModal.initInScope);

import * as fetchModal from './scripts/fetch-modal';
onInitModulesInScope(fetchModal.initInScope);

import * as slider from '@elements/slider';
onInitModulesInScope(slider.createInitInScope('.js-img-content-teaser-slider-reduced', {
    nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow slider__arrow--big" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-right"></span></button>',
    prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow slider__arrow--big" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-left"></span></button>',
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.3
            }
        },
    ]
}));

onInitModulesInScope(slider.createInitInScope('.js-styled-product-slider', {
    nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-right"></span></button>',
    prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-left"></span></button>',
    infinite: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        },
    ]
}));


import * as productImgSlider from './scripts/product-img-slider';
onInitModulesInScope(productImgSlider.initInScope);

import * as changeProduct from './scripts/change-product';
onInitModulesInScope(changeProduct.initInScope);

import * as animationScaleUp from './scripts/animation-scale-up';
onInitModulesInScope(animationScaleUp.initInScope);

import * as showAllContent from './scripts/show-all-content';
onInitModulesInScope(showAllContent.initInScope);

import * as scrollDetect from './scripts/scroll-detect';
onInitModulesInScope(scrollDetect.initInScope);

import * as hotspot from './scripts/hotspot';
onInitModulesInScope(hotspot.initInScope);

import * as initModal from './scripts/init-modal';
onInitModulesInScope(initModal.initInScope);

import * as buyLocal from './scripts/buy-local-helper';

// check if user reached bottom
$(window).scroll(function() {
    if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
        $('body').addClass('is-bottom');
    }else{
        if($('body').hasClass('is-bottom')){
            $('body').removeClass('is-bottom');
        }
    }
});

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})(jQuery);
